import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";
import { useSite } from "@/i18n/useSite";
import { SectionHeading } from "./Section";

const BARS = ["bg-[var(--coral)]", "bg-[var(--blue)]", "bg-[var(--sun)]"];

export const Testimonials = () => {
  const t = useT();
  const { TESTIMONIALS } = useSite();
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });

  return (
    <section className="py-16 lg:py-24 bg-[var(--blue-tint)]" data-testid="testimonials-section">
      <div className="container-x">
        <SectionHeading eyebrow={t("In their words")} title={t("What the people we support say")} text={t("Don't just take our word for it – hear from participants and families.")} />
        <div ref={ref} className="scroll-x mt-10" data-testid="testimonial-track">
          {TESTIMONIALS.map((tm, i) => (
            <article key={tm.name} className="w-[85%] sm:w-[60%] lg:w-[46%] bg-white corner-tr flex flex-col overflow-hidden" data-testid={`testimonial-card-${i}`}>
              <div className="p-8 sm:p-10 flex-1">
                <p className="text-xl sm:text-2xl font-medium leading-snug text-[var(--blue)]">“{tm.text}”</p>
                <p className="mt-6 text-sm font-semibold text-[var(--ink)]" data-testid="testimonial-name">{tm.name} <span className="font-normal text-[var(--muted)]">· {tm.role}</span></p>
              </div>
              <div className={`h-2.5 ${BARS[i % BARS.length]}`} />
            </article>
          ))}
        </div>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button onClick={() => scroll(-1)} aria-label={t("Previous testimonials")} data-testid="testimonial-prev" className="w-11 h-11 rounded-full bg-white text-[var(--blue)] flex items-center justify-center hover:bg-[var(--blue)] hover:text-white transition-colors"><ChevronLeft size={20} /></button>
          <button onClick={() => scroll(1)} aria-label={t("Next testimonials")} data-testid="testimonial-next" className="w-11 h-11 rounded-full bg-[var(--blue)] text-white flex items-center justify-center hover:bg-[var(--blue-dark)] transition-colors"><ChevronRight size={20} /></button>
        </div>
      </div>
    </section>
  );
};
